/**
 * @fileoverview Zod schema for the bank detail dialog's inline "Edit Target" form.
 * @description Same period model as the legacy per-tenant target — a period *type* plus a
 * specific period *value*, never free start/end dates ("Custom target date ranges are not
 * supported"); the dates are derived via period.utils.ts's computePeriod once this validates. The
 * owner isn't editable here (that's Reassign). Every issue message is a translation key, translated
 * only at the display call site in EditTargetForm.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

export const editTargetFormSchema = z.object({
  name: z.string().trim().min(1, 'sales.tenantDetail.editTarget.errors.nameRequired'),
  periodType: z.enum(['Monthly', 'Quarterly', 'Half-Yearly', 'Annual']),
  periodValue: z.string().trim().min(1, 'sales.tenantDetail.editTarget.errors.periodRequired'),
  priority: z.enum(['High', 'Medium', 'Low']),
})

export type EditTargetFormValues = z.infer<typeof editTargetFormSchema>
